import {
  AlignCenter,
  AlignLeft,
  AlignRight,
  Bold,
  CaseSensitive,
  Italic,
  PaintBucket,
  Underline,
} from 'lucide-react';
import { css } from 'styled-system/css';

const FORMAT_ICONS = [
  Bold,
  Italic,
  Underline,
  CaseSensitive,
  PaintBucket,
  AlignLeft,
  AlignCenter,
  AlignRight,
];

export function FormatStrip() {
  return (
    <div
      className={css({
        display: 'flex',
        alignItems: 'center',
        gap: '1',
        height: '28px',
        paddingInline: '2',
        borderBottom: '1px solid token(colors.border.hairline)',
        color: 'text.muted',
        flexShrink: 0,
        overflow: 'hidden',
      })}
    >
      <span
        className={css({
          fontSize: '2xs',
          paddingInline: '1.5',
          flexShrink: 0,
        })}
      >
        Default
      </span>
      <span
        className={css({
          fontFamily: 'mono',
          fontSize: '2xs',
          paddingInline: '1.5',
          flexShrink: 0,
        })}
      >
        10
      </span>
      <span
        className={css({
          width: '1px',
          height: '12px',
          background: 'border.hairline',
          marginInline: '1',
          flexShrink: 0,
        })}
      />
      {FORMAT_ICONS.map((Icon, i) => (
        <span
          key={i}
          className={css({
            display: 'inline-flex',
            padding: '1',
            '& > svg': { width: '12px', height: '12px' },
          })}
        >
          <Icon strokeWidth={2} />
        </span>
      ))}
    </div>
  );
}
